/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2025, Zumper
 */

import { checkLoggedIn, getUser } from '@zcode-ui/web-zumper-global-state'
import { reviveBizos } from '@zcode/bizos'
import { localStorageSingleton } from '@zcode/nr-utils'
import type { GetState, SendMessageArgs } from '@zcode/state-type'
import type { Dispatch } from '../../modules/types'

const PENDING_MESSAGE = 'pendingMessage'
const TEN_MINUTES_IN_DAYS = 10 / 24 / 60

const deletePendingMessage = () => {
  localStorageSingleton.del(PENDING_MESSAGE)
}

export const getPendingMessage = (): SendMessageArgs | undefined => {
  const pendingMessage = localStorageSingleton.getx(PENDING_MESSAGE)
  if (!pendingMessage) {
    // if it has expired, delete it
    localStorageSingleton.del(PENDING_MESSAGE)
  }
  reviveBizos(pendingMessage)
  return pendingMessage
}

export const setPendingMessage = (sendMessageArgs: SendMessageArgs) => {
  localStorageSingleton.setx(PENDING_MESSAGE, sendMessageArgs, TEN_MINUTES_IN_DAYS)
}

export const processPendingMessage = () => async (dispatch: Dispatch, getState: GetState) => {
  const pendingMessage = getPendingMessage()
  const state = getState()
  if (pendingMessage && checkLoggedIn(state)) {
    if (getUser(state).email.toLowerCase() === pendingMessage.messageData.email?.toLowerCase()) {
      // the + on the next line is to stop yarn verify-workspace --check-circular from complaining
      dispatch((await import('./sendMessage' + '.action')).sendMessage(pendingMessage))
    }
    deletePendingMessage()
  }
}
